import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, ControlValueAccessor, FormControl } from '@angular/forms';
import { BtTextareaModel } from '../bt-textarea.model';

@Component({
    selector: 'bt-textarea-form',
    providers: [
      {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => BtTextareaFormComponent),
        multi: true
      },
      {
        provide: NG_VALIDATORS,
        useExisting: forwardRef(() => BtTextareaFormComponent),
        multi: true
      }
    ],
    templateUrl: './bt-textarea-form.component.html',
    styleUrls: ['./bt-textarea-form.component.scss']
})
export class BtTextareaFormComponent implements ControlValueAccessor {
    @Input() model: BtTextareaModel;
    @Input() value: any;

    propagateChange = (_: any) => {};
    registerOnChange(fn: any) { this.propagateChange = fn; }
    registerOnTouched() {}
    writeValue(value: string) {
        this.value = value; 
    }

	validate({ value }: FormControl) {
		const isValid = (this.model as any).required && !value;
		return isValid && {
		  	invalid: true
		};
	}

  onInputChanged(event: any) {
    this.value = event.target.value.replace(/\r?\n/g, '\n');
    this.propagateChange(event.target.value);
  }
}